import { Cluster } from 'frontend/clusters'
import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'
import { Location } from 'frontend/locations'
import { markRaw } from 'vue'

export const StagingAreaDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [
    'id',
    'eid',
    'name',
    'has_minimum_vehicles_allotment',
    'has_subfleet',
    'has_welcome_desk',
    'updated_at',
    'created_at',
    // Arel relations
    {
      locations: ['id', 'name', 'time_zone', { cluster: ['id', 'name', 'time_zone'] }],
    },
    { clusters: ['id', 'name', 'time_zone'] },
  ],
  subscriptions: {
    items: 'StagingAreasChannel',
  },
  defaultColumns: [
    'eid',
    'name',
    'locations',
    'hasMinimumVehiclesAllotment',
    'hasSubfleet',
    'hasWelcomeDesk',
    'updatedAt',
  ],
  columnConfig: {
    eid: {
      label: 'EID',
      header: {
        sort: 'eid',
      },
      cell: {
        kind: 'simple',
        path: 'eid',
      },
    },
    name: {
      label: 'Name',
      header: {
        sort: 'name',
      },
      cell: {
        kind: 'simple',
        path: 'name',
      },
    },
    locations: {
      label: 'Locations',
      cell: {
        kind: 'component',
        component: 'limited-components-list',
        componentProps: item => ({
          items: item.locations,
          limit: 5,
          component: markRaw(Location),
          componentProps: location => ({
            location,
            minWidth: 250,
          }),
        }),
      },
    },
    clusters: {
      label: 'Clusters',
      cell: {
        kind: 'component',
        component: 'limited-components-list',
        componentProps: item => ({
          items: item.clusters,
          limit: 5,
          component: markRaw(Cluster),
          componentProps: cluster => ({
            cluster,
            minWidth: 250,
          }),
        }),
      },
    },
    hasMinimumVehiclesAllotment: {
      label: 'MVA',
      header: {
        sort: 'hasMinimumVehiclesAllotment',
      },
      cell: {
        kind: 'component',
        component: 'true-false-label',
        componentProps: sa => ({
          item: sa?.hasMinimumVehiclesAllotment,
        }),
      },
    },
    hasSubfleet: {
      label: 'Subfleet',
      header: {
        sort: 'hasSubfleet',
      },
      cell: {
        kind: 'component',
        component: 'true-false-label',
        componentProps: sa => ({
          item: sa?.hasSubfleet,
        }),
      },
    },
    hasWelcomeDesk: {
      label: 'Welcome desk',
      header: {
        sort: 'hasWelcomeDesk',
      },
      cell: {
        kind: 'component',
        component: 'true-false-label',
        componentProps: sa => ({
          item: sa?.hasWelcomeDesk,
        }),
      },
    },
    timeZone: {
      label: 'Time zone',
      header: {
        sort: 'timeZone',
      },
      cell: {
        kind: 'simple',
        path: 'timeZone',
      },
    },
    createdAt: {
      label: 'Created datetime',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({ t: item.createdAt }),
      },
    },
    createdAtTime: {
      label: 'Created time',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item.createdAt,
          format: 'timeOnly',
        }),
      },
    },
    createdAtDate: {
      label: 'Created date',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item.createdAt,
          format: 'dateOnly',
        }),
      },
    },
    updatedAt: {
      label: 'Updated datetime',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({ t: item.updatedAt }),
      },
    },
    updatedAtTime: {
      label: 'Updated time',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item.updatedAt,
          format: 'timeOnly',
        }),
      },
    },
    updatedAtDate: {
      label: 'Updated date',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: item => ({
          t: item.updatedAt,
          format: 'dateOnly',
        }),
      },
    },
  },
}
